// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  list(context) {
    return new Promise(resolve => {
      NewApiService.get("admin/scheduler")
        .then(({ data }) => {      
          context.commit("set_events", data);
          resolve(data);
        })
    });
  },
  create(context, event){
      return new Promise(resolve => {
        NewApiService.post("admin/scheduler", event).
          then(({data}) => {
              resolve(data)
          })
          .catch(({ response }) => {
            context.commit("set_error", response.data.errors);
          });
      })
  },
  update(context, event){
      return new Promise(resolve => {
          NewApiService.put("admin/scheduler/"+event.id, event).
          then(({data}) => {
              resolve(data)
          })
          .catch(({ response }) => {
            context.commit("set_error", response.data.errors);
          });
      })
  },
  delete(context, event){
      return new Promise(resolve => {
          NewApiService.delete("admin/scheduler/"+event.id, event).
          then(({data}) => {
              resolve(data)
          })
          .catch(({ response }) => {
            context.commit("set_error", response.data.errors);
          });
      })
  }
};
